/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

import { getAuth, signInWithCustomToken, User } from "firebase/auth";
import { fetchCloudRun } from "../Helper";
import { store } from "@/store";
import { UserStore } from "@/store/constants";

export const signInWithPermissions = async () => {
  const user = store.getters[UserStore.Getters.USER] as User;
  const idToken = await user.getIdToken();
  store.commit(UserStore.Mutations.SET_ID_TOKEN, idToken);
  const result = await fetchCloudRun(
    "https://services.chatcaptain.de/bot/auth/signin",
    "POST"
  );
  const token = result.result;
  await signInWithCustomToken(getAuth(), token);
  const idTokenUpdated = await user.getIdToken();
  store.commit(UserStore.Mutations.SET_ID_TOKEN, idTokenUpdated);
};
